import React, { Component } from 'react';

class Directives extends Component<any> {
  render() {
    const { dIf } = this.props;
    if ( dIf ) {
      return this.props.children;
    }
    return null;
  }
}

export default Directives;
